var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 651,
    viewBox: "0 0 650 651",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 325.175,
    cy: 325.175,
    r: 325.175,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M454.326 241.766C471.077 258.374 470.938 282.395 470.726 318.759C470.709 321.466 470.695 324.271 470.683 327.176C470.602 348.756 470.545 364.348 468.279 377.496C466.35 388.707 461.896 404.866 445.582 415.741C424.918 429.515 394.053 429.826 326.428 430.502C315.866 430.607 306.127 430.686 297.141 430.686C243.565 430.686 216.632 427.85 199.427 410.75C181.504 392.942 181.604 366.716 181.752 327.017C181.917 282.723 182.017 255.987 204.471 239.39C223.843 225.071 251.977 224.694 313.611 223.866L325.912 223.696C402.728 222.598 434.523 222.142 454.32 241.77L454.326 241.766ZM428.165 318.515C428.284 297.621 428.41 276.011 424.357 271.995C419.327 267.008 396.754 265.856 366.71 265.856C354.347 265.856 340.716 266.051 326.523 266.254L314.183 266.424C270.025 267.016 238.122 267.445 229.768 273.616C224.497 277.512 224.411 300.527 224.311 327.178C224.218 351.926 224.13 375.301 229.425 380.561C237.737 388.821 282.607 388.37 326.002 387.94C375.833 387.443 411.834 387.083 421.97 380.327C427.936 376.35 428.012 355.658 428.12 327.017C428.129 324.083 428.148 321.251 428.165 318.515Z",
    fill: "url(#paint0_linear_1348_117575)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.222 0.292969C145.921 0.292969 0.046875 146.167 0.046875 325.468C0.046875 504.769 145.921 650.643 325.222 650.643C504.523 650.643 650.397 504.769 650.397 325.468C650.397 146.167 504.523 0.292969 325.222 0.292969ZM325.222 634.426C154.863 634.426 16.2644 495.827 16.2644 325.468C16.2644 155.109 154.863 16.5105 325.222 16.5105C495.581 16.5105 634.18 155.106 634.18 325.468C634.18 495.83 495.581 634.426 325.222 634.426Z",
    fill: "url(#paint1_linear_1348_117575)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1348_117575",
    x1: 181.727,
    y1: 223.27,
    x2: 470.771,
    y2: 223.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1348_117575",
    x1: 0.046875,
    y1: 0.292969,
    x2: 650.397,
    y2: 0.292969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#616161"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMark);
export default __webpack_public_path__ + "static/media/logo-mark.e95035a2023f5f6681d46a8a0e06eb25.svg";
export { ForwardRef as ReactComponent };